// DOM ELEMENTS
const showModalBtn = document.querySelector('.btn__showModal');
const addModalForm = document.querySelector('.add__content');

// Setup modal functionality
function setupModal() {
  if (showModalBtn) {
    showModalBtn.addEventListener('click', () => {
      addModalForm.classList.remove('hidden');
    });
  }
}

export { setupModal };
